import { useSelector } from "react-redux";
import { secondsToHHMMSS, sumOfRecordCounts } from "../../../helper/utility";
import { Constants } from "../../Common/Constants";
import AreaGraph from "../../Common/Graphs/AreaGraph";

const Weekly = () => {
  // const { workoutanalytics } = useSelector((store) => store.Reports);
  const workoutSessionSplit = useSelector((store) => store.WorkOutAnalyticsReportReducer.workoutSessionSplitMinutes.duration);
  const sumOfWorkoutSessionSplit = sumOfRecordCounts(workoutSessionSplit);

  return (
    <div className="row mt-4">
      <div id="chart" className="col-md-4">
        <AreaGraph
          // data={workoutanalytics?.workoutSessionSplit}
          data={workoutSessionSplit}
          title={`${Constants.workoutSessionSplitInMins} ${secondsToHHMMSS(sumOfWorkoutSessionSplit)}`}
          format=""
          yAxisType={"time"}
        />
      </div>
      <div id="html-dist"></div>
    </div>
  );
};

export default Weekly;
